import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-finish-activity',
  templateUrl: './finish-activity.component.html',
  styleUrls: ['./finish-activity.component.scss'],
})
export class FinishActivityComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
